import { render, staticRenderFns } from "./wendang_list.vue?vue&type=template&id=6c2f2b4e&scoped=true&"
import script from "./wendang_list.vue?vue&type=script&lang=js&"
export * from "./wendang_list.vue?vue&type=script&lang=js&"
import style0 from "./wendang_list.vue?vue&type=style&index=0&id=6c2f2b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f2b4e",
  null
  
)

export default component.exports